import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {ApiAdminCustomerService} from "../../../../../services/api/admin/admin-customer-api/admin-customer-api.service";
import {DialogService} from "../../../../../services/dialog-service/dialog.service";
import {AdminCustomersComponentDialog} from "./admin-customers-create-edit-dialog/admin-customers-create-edit-dialog.component";
import {ModalConfirmationComponent} from "../../../../../shared/modal-confirmation/modal-confirmation.component";
import { SdeskHelper } from 'src/app/shared/helper/SdeskHelper';

@Component({
  selector: 'app-admin-customers',
  templateUrl: './admin-customers.html',
  styleUrls: ['./admin-customers.css']
})
export class AdminCustomersComponent implements OnInit {

  data;
  allData;
  correct_data;
  isLoading = true;

  searchTerm = '';


  constructor(private apiAdminCustomerService: ApiAdminCustomerService, private dialogService: DialogService, private viewReference: ViewContainerRef) {
    this.getData();
  }

  //Paginator variables
  first: number = 1;
  rows: number = 50;
  showingRowscount: number = 50;
  fromRowscount: number = 1;
  currentPage: number = 1;
  currentPerPage: number= 50;
  public CustomerPage_storage: {Tab_name: string;perPage: number; page: number }[];
  viewName: string;

  ngOnInit(): void {
  }

  filteredData(){
    const searchTerm = this.searchTerm.toLocaleLowerCase();

    if(!this.searchTerm){
      return this.allData;
    } else {
      return this.allData.filter(row => {
        return row.Name.toLocaleLowerCase().includes(searchTerm)
      });
    }
  }

  getData(){
    this.isLoading = true;
    this.CustomerPage_storage = SdeskHelper.getViewResults('customer_page_pagination');

    const Tab = this.CustomerPage_storage.find(item => item.Tab_name === "customers");

    this.currentPage = Tab?.page ?? 1;
    this.currentPerPage = Tab?.perPage ?? 50;

    this.rows = this.currentPerPage;
    this.first = this.currentPage;

    console.log(this.CustomerPage_storage)
    this.apiAdminCustomerService.listAllPaginated(this.currentPage,this.currentPerPage).then(response => {
      this.data = response;
      this.isLoading = false;
    })

    this.apiAdminCustomerService.listAll().then(response => {
      this.allData= response;
      this.isLoading = false;
    }).catch(error => {
      this.isLoading = false;
      if (error.status === 403) {
        window.location.href = '/';  // Redirect to self-service
      } else {
        console.log('Unhandled error:', error);
      }
    });

    SdeskHelper.storePaginationData('customer_page_pagination', "Tab_name", "customers", this.viewName, this.currentPerPage, this.currentPage);
    this.setFirstPageIndex();

  }

  //Function uses for pagination
  onPageChange(event) {
    this.currentPage = event.page + 1;
    this.rows = event.rows;
    this.first = event.first;
    this.currentPerPage = this.rows;

    this.showingRowscount = event.page * event.rows;
    this.fromRowscount = (event.page - 1) * event.rows + 1;

    SdeskHelper.storePaginationData('customer_page_pagination', "Tab_name", "customers", this.viewName, this.currentPerPage, this.currentPage);
    this.getData(); // Fetch the updated data for the new page
  }

  setFirstPageIndex() {
    this.first = (this.currentPage - 1) * this.rows;
  }

  create(){
    // Replace null with Component
    this.dialogService.createDialog(AdminCustomersComponentDialog, null, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  edit(id){
    // Replace null with Component
    this.dialogService.createDialog(AdminCustomersComponentDialog, id, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  delete(id){
    this.dialogService.createDialog(ModalConfirmationComponent, 'Are you sure?', this.viewReference)
      .then(confirmed => {
        this.apiAdminCustomerService.delete(id).then(response => this.getData())
      }, cancelled => null)
  }

  get_correct_data(getall = false) {
    if (this.searchTerm) {
      return this.filteredData() ?? {};
    }
    return (getall ? this.allData : this.data) ?? {};
  }
}
